import { render, staticRenderFns } from "./ThresholdBar.vue?vue&type=template&id=08b6de2e&scoped=true&"
import script from "./ThresholdBar.vue?vue&type=script&lang=js&"
export * from "./ThresholdBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6de2e",
  null
  
)

export default component.exports